import { useQuery } from "@tanstack/react-query";
import { reactQueryOptions } from "src/config/reactQuery.config";
import {
  getProductPackage,
  getProductPackageDetail,
  getProductPackageVariantList,
} from "src/services/ProductPackage.service";
import {
  ProductPackageDetailRequestBody,
  ProductPackageParams,
  ProductPackageVariantListParams,
} from "./interfaces";
import { useGetAccessPermission } from "src/hooks/useGetAccessPermission";
import { AccessResource, ActionType } from "src/types/accessControl";

export const useGetProductPackage = (params: ProductPackageParams) => {
    const isAllowedPackageList = useGetAccessPermission({
      resource: AccessResource["Product Management - Product Package"],
      action: ActionType["Read"],
    });
  return useQuery({
    ...reactQueryOptions,
    queryKey: ["product-package", params],
    queryFn: () => getProductPackage(params),
    enabled: isAllowedPackageList
  });
};

export const useGetProductPackageDetail = (
  requestBody: ProductPackageDetailRequestBody
) => {
  return useQuery({
    ...reactQueryOptions,
    queryKey: ["product-package-detail", requestBody],
    queryFn: () => getProductPackageDetail(requestBody),
  });
};

export const useGetProductPackageVariantList = (
  params: ProductPackageVariantListParams
) => {
  const isAllowedPackageList = useGetAccessPermission({
    resource: AccessResource["Product Management - Product Package"],
    action: ActionType["Read"],
  });
  return useQuery({
    ...reactQueryOptions,
    queryKey: ["product-package-variant-list", params],
    queryFn: () => getProductPackageVariantList(params),
    enabled: isAllowedPackageList,
  });
};
